import { Link } from "react-router-dom";
import styles from './header.module.css';
import { useState } from "react";

function Header() {
    const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);

    const toggleMobileMenu = () => {
        setMobileMenuOpen(prev => !prev);
    };

    const closeMenu = () => setMobileMenuOpen(false);

    return (
            <nav className={styles.navbar}>
                {/* Mobile Hamburger */}
                <div className={styles.hamburger} onClick={toggleMobileMenu}>
                    {isMobileMenuOpen ? '✕' : '☰'}
                </div>

                {/* Desktop Nav Left */}
                <ul className={styles.desktopMenu}>
                    <li><Link to="/tuinhuizen">TUINHUIZEN</Link></li>
                    <li><Link to="/poolhouse">POOLHOUSE</Link></li>
                    <li><Link to="/overkappingen">OVERKAPPINGEN</Link></li>
                </ul>
                {/* Logo Center */}
                    <div className={styles.logoContainer}>
                        <Link to="/">
                            <img src="/images/color_logo.svg" alt="Logo" className={styles.logo} />
                        </Link>
                    </div>
                {/* Desktop Nav Right */}
                <ul className={styles.desktopMenu}>
                    <li><Link to="/carport">CARPORT</Link></li>
                    <li><Link to="/divers">DIVERSE WERKEN</Link></li>
                    <li><Link to="/contact">CONTACT</Link></li>
                </ul>

                {/* Mobile Menu */}
                {isMobileMenuOpen && (
                    <ul className={styles.mobileMenu}>
                        <li><Link to="/tuinhuizen" onClick={closeMenu}>TUINHUIZEN</Link></li>
                        <li><Link to="/carport" onClick={closeMenu}>CARPORT</Link></li>
                        <li><Link to="/poolhouse" onClick={closeMenu}>POOLHOUSE</Link></li>
                        <li><Link to="/overkappingen" onClick={closeMenu}>OVERKAPPINGEN</Link></li>
                        <li><Link to="/divers" onClick={closeMenu}>DIVERSE WERKEN</Link></li>
                        <li><Link to="/contact" onClick={closeMenu}>CONTACT</Link></li>
                    </ul>
                )}
            </nav>
    );
}

export default Header;
